// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.1
// source: events/shared/events.proto

/* eslint-disable */

export const protobufPackage = 'events.shared';

export enum Sport {
  UNKNOWN_SPORT = 0,
  FOOTBALL = 1,
  BASEBALL = 2,
  NBA = 3,
  UNRECOGNIZED = -1,
}

export function sportFromJSON(object: any): Sport {
  switch (object) {
    case 0:
    case 'UNKNOWN_SPORT':
      return Sport.UNKNOWN_SPORT;
    case 1:
    case 'FOOTBALL':
      return Sport.FOOTBALL;
    case 2:
    case 'BASEBALL':
      return Sport.BASEBALL;
    case 3:
    case 'NBA':
      return Sport.NBA;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return Sport.UNRECOGNIZED;
  }
}

export function sportToJSON(object: Sport): string {
  switch (object) {
    case Sport.UNKNOWN_SPORT:
      return 'UNKNOWN_SPORT';
    case Sport.FOOTBALL:
      return 'FOOTBALL';
    case Sport.BASEBALL:
      return 'BASEBALL';
    case Sport.NBA:
      return 'NBA';
    case Sport.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface Empty {}

export const Empty: MessageFns<Empty> = {
  fromJSON(_: any): Empty {
    return {};
  },

  toJSON(_: Empty): unknown {
    const obj: any = {};
    return obj;
  },
};

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
